import React from 'react';
import 'twin.macro';
import Button from 'components/Buttons/Button';
import { CheckIcon, PencilIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Input from 'components/Form/Input2';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  onChange: (v: string) => void;
  isEditable?: boolean;
  defaultOpen?: boolean;
}

export function AtelierTitle({
  title,
  onChange,
  isEditable,
  defaultOpen,
}: Props) {
  const { t } = useTranslation(['cahierJournal']);
  const [isEditing, setIsEditing] = React.useState(defaultOpen || false);
  const [newTitle, setNewTitle] = React.useState(title);
  if (isEditing) {
    return (
      <div tw="flex items-center gap-x-2 min-w-0">
        <div>
          <Input
            fill
            value={newTitle}
            onBlur={() => {
              onChange(newTitle);
              setIsEditing(false);
            }}
            onChange={e => setNewTitle(e?.target?.value || '')}
            onKeyDown={e => {
              e.stopPropagation(); // prevent closing the disclosure
              if (e.key === 'Enter') {
                onChange(newTitle);
                setIsEditing(false);
              }
              if (e.key === 'Escape') {
                setNewTitle(title);
                setIsEditing(false);
              }
              return;
            }}
            onClick={e => e.stopPropagation()}
            autoFocus
            aria-label={t('ateliers.title.input')}
          />
        </div>
        <div>
          <Button
            icon={CheckIcon}
            onClick={e => {
              e.stopPropagation();
              onChange(newTitle);
              setIsEditing(false);
            }}
            aria-label={t('ateliers.title.validate')}
            minimal
          />
          <Button
            icon={XMarkIcon}
            onClick={e => {
              e.stopPropagation();
              setNewTitle(title);
              setIsEditing(false);
            }}
            aria-label={t('ateliers.title.cancel')}
            minimal
          />
        </div>
      </div>
    );
  }
  return (
    <div tw="flex items-center gap-x-2 min-w-0">
      {title}
      {isEditable && (
        <Button
          icon={PencilIcon}
          iconSize="sm"
          onClick={e => {
            e.stopPropagation();
            setIsEditing(true);
          }}
          aria-label={t('ateliers.title.edit')}
          small
          minimal
        />
      )}
    </div>
  );
}
